import Vue from "vue"

const state = {

}

const mutations = {

}

const actions = {
    async fetchCollections({ dispatch }) {
        const { data, status } = await Vue.axios.get("/collections");
        if (status != 200) {
            await dispatch("generateSnackBarMessage", { message: 'Ocurrió un error al obtener los rubros', type: 'error' })
        };
        return { data, status };
    },
    async createCollection({ dispatch }, collection) {
        const formData = new FormData();
        formData.append('title', collection.title);
        formData.append('description', collection.description);
        formData.append('file_collection', collection.file_collection);
        formData.append('buy_url', collection.buy_url);
        const { data, status } = await Vue.axios.post("/collections", formData);
        if (status != 200 && status != 201) {
            await dispatch("createResponseMessage", { message: data.message || 'Ocurrió un error guardando los datos del rubro', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Se guardó correctamente', type: 'success' })
        }
        return { data, status };
    },
    async updateCollection({ dispatch }, collection) {
        const formData = new FormData();
        formData.append('title', collection.title);
        formData.append('description', collection.description);
        formData.append('buy_url', collection.buy_url);
        if (collection.file_collection) {
            formData.append('file_collection', collection.file_collection)
        }
        const { data, status } = await Vue.axios.post(`/collections/${collection.id}`, formData);
        if (status != 200 && status != 201 && status != 204) {
            await dispatch("createResponseMessage", { message: data.message || 'Ocurrió un error actualizando los datos del rubro', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Se guardó correctamente', type: 'success' })
        }
        return { data, status };
    },
    async removeCollection({ dispatch }, collection) {
        const { data, status } = await Vue.axios.delete(`/collections/${collection.id}`);
        if (status != 200 && status != 204) {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Ocurrió un error eliminando al rubro del sistema', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Rubro eliminado correctamente', type: 'success' })
        }
        return { data, status };
    }
}

export default { state, mutations, actions }